<header> </header>
<!-- begin main content -->
<div class="container" role="main" id="main-content">
  <div class="row">
    <div class="col-md-12 acl-container">
      <!-- left navigation -->
      <sideNav></sideNav>
      <!-- .end left navigation -->
      <div class="col-md-9">
        <h2>Older Adults - Other Services - Total People Served and Expenditures</h2>
        <p class="info mt-1">All fields are required</p>
        <div class="col-md-12 background-gray-lighter mb-1">
          <h2>Total Served and Service Units</h2>
        </div>
        <div class="col-md-9">
          <label for="totalServiceUnits" class="normal">Total estimated number of people served</label>
        </div>
        <div class="col-md-3 mb-1">
          <div [ngClass]="calculateOutlineColor(_sectionModel.totalServiceUnits.questionStatus)">
            <div>
              <input [(ngModel)]="_sectionModel.totalServiceUnits.elementValue" [disabled]="!_sectionModel.totalServiceUnits.isRequired"
                type="text" class="form-control" id="totalServiceUnits" (change)="unsavedChanges = true; _sectionModel.totalServiceUnits.elementValue = addComma(_sectionModel.totalServiceUnits.elementValue); updateTotals(); _sectionModel.totalServiceUnits = validate(_sectionModel.totalServiceUnits); checkValidForm()">
            </div>
          </div>
          <div *ngIf="!!_sectionModel.totalServiceUnits.dataEntryErrorMessage" class="alert alert-danger" role="alert">
            <i class="fa fa-times" aria-hidden="true"></i>
            <span class="sr-only">Error:</span>&nbsp;{{_sectionModel.totalServiceUnits.dataEntryErrorMessage}}
          </div>
          <div *ngIf="!_sectionModel.totalServiceUnits.dataEntryErrorMessage && (_sectionModel.totalServiceUnits.questionStatus == questionStatusEnum.L2InProgressError || _sectionModel.totalServiceUnits.questionStatus == questionStatusEnum.L2ValidatedWarning)"
            [ngClass]="setErrorDisplayType(_sectionModel.totalServiceUnits.questionStatus)" role="alert">
            <i *ngIf="_sectionModel.totalServiceUnits.questionStatus == questionStatusEnum.L2ValidatedWarning" class="fa fa-exclamation-triangle"
              aria-hidden="true"></i>
            <span *ngIf="_sectionModel.totalServiceUnits.questionStatus == questionStatusEnum.L2ValidatedWarning" class="sr-only">Warning:</span>
            <i *ngIf="_sectionModel.totalServiceUnits.questionStatus != questionStatusEnum.L2ValidatedWarning" class="fa fa-times"
              aria-hidden="true"></i>
            <span *ngIf="_sectionModel.totalServiceUnits.questionStatus != questionStatusEnum.L2ValidatedWarning" class="sr-only">Error:</span>
            &nbsp;{{_sectionModel.totalServiceUnits.businessErrorMessage}}
          </div>
        </div>

        <div class="col-md-12 background-gray-lighter mb-1">
          <h2>Expenditures</h2>
        </div>



        <div class="col-md-9">
            <label for="expendC1" class="normal">Title III C1 expenditure</label>
          </div>
          <div class="col-md-3 mb-1">
            <div [ngClass]="(_sectionModel.expendC1.dataEntryErrorMessage)?'has-error form-group':'form-group'">
              <div class="input-group">
                <div class="input-group-addon">$</div>
                <input [(ngModel)]="_sectionModel.expendC1.elementValue" [disabled]="!_sectionModel.expendC1.isRequired" type="text"
                  class="form-control" id="expendC1" (change)="unsavedChanges = true; _sectionModel.expendC1.elementValue = addDecimals(_sectionModel.expendC1.elementValue); updateTotals(); checkValidForm()"
                  readonly>
              </div>
            </div>
            <div *ngIf="_sectionModel.expendC1.dataEntryErrorMessage" class="has-error" role="alert">
              <p class="help-block normal">
                <i class="fa fa-times fa-2x help-block" aria-hidden="true"></i>
                {{_sectionModel.expendC1.dataEntryErrorMessage}}</p>
            </div>
            <div *ngIf="!_sectionModel.expendC1.dataEntryErrorMessage && _sectionModel.expendC1.questionStatus == questionStatusEnum.L2ValidatedWarning"
              class="has-warning" role="alert">
              <p class="help-block normal">
                <i class="fa fa-warning fa-2x help-block" aria-hidden="true"></i>
                {{_sectionModel.expendC1.businessErrorMessage}}</p>
            </div>
            <div *ngIf="!_sectionModel.expendC1.dataEntryErrorMessage && _sectionModel.expendC1.questionStatus == questionStatusEnum.L2InProgressError"
              class="has-error" role="alert">
              <p class="help-block normal">
                <i class="fa fa-times fa-2x help-block" aria-hidden="true"></i>
                {{_sectionModel.expendC1.businessErrorMessage}}</p>
            </div>
          </div>

          <div class="col-md-9">
            <label for="expendC2" class="normal">Title III C2 expenditure</label>
          </div>
          <div class="col-md-3 mb-1">
            <div [ngClass]="(_sectionModel.expendC2.dataEntryErrorMessage)?'has-error form-group':'form-group'">
              <div class="input-group">
                <div class="input-group-addon">$</div>
                <input [(ngModel)]="_sectionModel.expendC2.elementValue" [disabled]="!_sectionModel.expendC2.isRequired" type="text"
                  class="form-control" id="expendC2" (change)="unsavedChanges = true; _sectionModel.expendC2.elementValue = addDecimals(_sectionModel.expendC2.elementValue); updateTotals(); checkValidForm()"
                  readonly>
              </div>
            </div>
            <div *ngIf="_sectionModel.expendC2.dataEntryErrorMessage" class="has-error" role="alert">
              <p class="help-block normal">
                <i class="fa fa-times fa-2x help-block" aria-hidden="true"></i>
                {{_sectionModel.expendC2.dataEntryErrorMessage}}</p>
            </div>
            <div *ngIf="!_sectionModel.expendC2.dataEntryErrorMessage && _sectionModel.expendC2.questionStatus == questionStatusEnum.L2ValidatedWarning"
              class="has-warning" role="alert">
              <p class="help-block normal">
                <i class="fa fa-warning fa-2x help-block" aria-hidden="true"></i>
                {{_sectionModel.expendC2.businessErrorMessage}}</p>
            </div>
            <div *ngIf="!_sectionModel.expendC2.dataEntryErrorMessage && _sectionModel.expendC2.questionStatus == questionStatusEnum.L2InProgressError"
              class="has-error" role="alert">
              <p class="help-block normal">
                <i class="fa fa-times fa-2x help-block" aria-hidden="true"></i>
                {{_sectionModel.expendC2.businessErrorMessage}}</p>
            </div>
          </div>
            
          <div class="col-md-9">
            <label for="partB" class="normal">Title III Part B expenditure</label>
          </div>
          <div class="col-md-3 mb-1">
            <div [ngClass]="(_sectionModel.partB.dataEntryErrorMessage)?'has-error form-group':'form-group'">
              <div class="input-group">
                <div class="input-group-addon">$</div>
                <input [(ngModel)]="_sectionModel.partB.elementValue" [disabled]="!_sectionModel.partB.isRequired" type="text"
                  class="form-control" id="partB" (change)="unsavedChanges = true; _sectionModel.partB.elementValue = addDecimals(_sectionModel.partB.elementValue); updateTotals(); checkValidForm()"
                  readonly>
              </div>
            </div>
            <div *ngIf="_sectionModel.partB.dataEntryErrorMessage" class="has-error" role="alert">
              <p class="help-block normal">
                <i class="fa fa-times fa-2x help-block" aria-hidden="true"></i>
                {{_sectionModel.partB.dataEntryErrorMessage}}</p>
            </div>
            <div *ngIf="!_sectionModel.partB.dataEntryErrorMessage && _sectionModel.partB.questionStatus == questionStatusEnum.L2ValidatedWarning"
              class="has-warning" role="alert">
              <p class="help-block normal">
                <i class="fa fa-warning fa-2x help-block" aria-hidden="true"></i>
                {{_sectionModel.partB.businessErrorMessage}}</p>
            </div>
            <div *ngIf="!_sectionModel.partB.dataEntryErrorMessage && _sectionModel.partB.questionStatus == questionStatusEnum.L2InProgressError"
              class="has-error" role="alert">
              <p class="help-block normal">
                <i class="fa fa-times fa-2x help-block" aria-hidden="true"></i>
                {{_sectionModel.partB.businessErrorMessage}}</p>
            </div>
          </div>
  

        <div class="col-md-9">
          <label for="expend" class="normal">Title III expenditure</label>
        </div>
        <div class="col-md-3 mb-1">
          <div [ngClass]="(_sectionModel.expend.dataEntryErrorMessage)?'has-error form-group':'form-group'">
            <div class="input-group">
              <div class="input-group-addon">$</div>
              <input [(ngModel)]="_sectionModel.expend.elementValue" [disabled]="!_sectionModel.expend.isRequired" type="text"
                class="form-control" id="expend" (change)="unsavedChanges = true; _sectionModel.expend.elementValue = addDecimals(_sectionModel.expend.elementValue); updateTotals(); checkValidForm()"
                readonly>
            </div>
          </div>
          <div *ngIf="_sectionModel.expend.dataEntryErrorMessage" class="has-error" role="alert">
            <p class="help-block normal">
              <i class="fa fa-times fa-2x help-block" aria-hidden="true"></i>
              {{_sectionModel.expend.dataEntryErrorMessage}}</p>
          </div>
          <div *ngIf="!_sectionModel.expend.dataEntryErrorMessage && _sectionModel.expend.questionStatus == questionStatusEnum.L2ValidatedWarning"
            class="has-warning" role="alert">
            <p class="help-block normal">
              <i class="fa fa-warning fa-2x help-block" aria-hidden="true"></i>
              {{_sectionModel.expend.businessErrorMessage}}</p>
          </div>
          <div *ngIf="!_sectionModel.expend.dataEntryErrorMessage && _sectionModel.expend.questionStatus == questionStatusEnum.L2InProgressError"
            class="has-error" role="alert">
            <p class="help-block normal">
              <i class="fa fa-times fa-2x help-block" aria-hidden="true"></i>
              {{_sectionModel.expend.businessErrorMessage}}</p>
          </div>
        </div>
        <div class="col-md-9">
          <label for="expendOtherState" class="normal">Other state expenditure</label>
        </div>
        <div class="col-md-3 mb-1">
          <div [ngClass]="(_sectionModel.expendOtherState.dataEntryErrorMessage)?'has-error form-group':'form-group'">
            <div class="input-group">
              <div class="input-group-addon">$</div>
              <input [(ngModel)]="_sectionModel.expendOtherState.elementValue" [disabled]="!_sectionModel.expendOtherState.isRequired"
                type="text" class="form-control" id="expendOtherState" (change)="unsavedChanges = true; _sectionModel.expendOtherState.elementValue = addDecimals(_sectionModel.expendOtherState.elementValue); updateTotals(); checkValidForm()"
                readonly>
            </div>
          </div>
          <div *ngIf="_sectionModel.expendOtherState.dataEntryErrorMessage" class="has-error" role="alert">
            <p class="help-block normal">
              <i class="fa fa-times fa-2x help-block" aria-hidden="true"></i>
              {{_sectionModel.expendOtherState.dataEntryErrorMessage}}</p>
          </div>
          <div *ngIf="!_sectionModel.expendOtherState.dataEntryErrorMessage && _sectionModel.expendOtherState.questionStatus == questionStatusEnum.L2ValidatedWarning"
            class="has-warning" role="alert">
            <p class="help-block normal">
              <i class="fa fa-warning fa-2x help-block" aria-hidden="true"></i>
              {{_sectionModel.expendOtherState.businessErrorMessage}}</p>
          </div>
          <div *ngIf="!_sectionModel.expendOtherState.dataEntryErrorMessage && _sectionModel.expendOtherState.questionStatus == questionStatusEnum.L2InProgressError"
            class="has-error" role="alert">
            <p class="help-block normal">
              <i class="fa fa-times fa-2x help-block" aria-hidden="true"></i>
              {{_sectionModel.expendOtherState.businessErrorMessage}}</p>
          </div>
        </div>
        <div class="col-md-9">
          <label for="expendOtherNonState" class="normal">Other non-state expenditure</label>
        </div>
        <div class="col-md-3 mb-1">
          <div [ngClass]="(_sectionModel.expendOtherNonState.dataEntryErrorMessage)?'has-error form-group':'form-group'">
            <div class="input-group">
              <div class="input-group-addon">$</div>
              <input [(ngModel)]="_sectionModel.expendOtherNonState.elementValue" [disabled]="!_sectionModel.expendOtherNonState.isRequired"
                type="text" class="form-control" id="expendOtherNonState" (change)="unsavedChanges = true; _sectionModel.expendOtherNonState.elementValue = addDecimals(_sectionModel.expendOtherNonState.elementValue); updateTotals(); checkValidForm()"
                readonly>
            </div>
          </div>
          <div *ngIf="_sectionModel.expendOtherNonState.dataEntryErrorMessage" class="has-error" role="alert">
            <p class="help-block normal">
              <i class="fa fa-times fa-2x help-block" aria-hidden="true"></i>
              {{_sectionModel.expendOtherNonState.dataEntryErrorMessage}}</p>
          </div>
          <div *ngIf="!_sectionModel.expendOtherNonState.dataEntryErrorMessage && _sectionModel.expendOtherNonState.questionStatus == questionStatusEnum.L2ValidatedWarning"
            class="has-warning" role="alert">
            <p class="help-block normal">
              <i class="fa fa-warning fa-2x help-block" aria-hidden="true"></i>
              {{_sectionModel.expendOtherNonState.businessErrorMessage}}</p>
          </div>
          <div *ngIf="!_sectionModel.expendOtherNonState.dataEntryErrorMessage && _sectionModel.expendOtherNonState.questionStatus == questionStatusEnum.L2InProgressError"
            class="has-error" role="alert">
            <p class="help-block normal">
              <i class="fa fa-times fa-2x help-block" aria-hidden="true"></i>
              {{_sectionModel.expendOtherNonState.businessErrorMessage}}</p>
          </div>
        </div>
        <div class="col-md-9">
          <label for="programIncome" class="normal">Program income expended</label>
        </div>
        <div class="col-md-3 mb-1">
          <div [ngClass]="(_sectionModel.programIncome.dataEntryErrorMessage)?'has-error form-group':'form-group'">
            <div class="input-group">
              <div class="input-group-addon">$</div>
              <input [(ngModel)]="_sectionModel.programIncome.elementValue" [disabled]="!_sectionModel.programIncome.isRequired"
                type="text" class="form-control" id="programIncome" (change)="unsavedChanges = true; _sectionModel.programIncome.elementValue = addDecimals(_sectionModel.programIncome.elementValue); updateTotals(); checkValidForm()"
                readonly>
            </div>
          </div>
          <div *ngIf="_sectionModel.programIncome.dataEntryErrorMessage" class="has-error" role="alert">
            <p class="help-block normal">
              <i class="fa fa-times fa-2x help-block" aria-hidden="true"></i>
              {{_sectionModel.programIncome.dataEntryErrorMessage}}</p>
          </div>
          <div *ngIf="!_sectionModel.programIncome.dataEntryErrorMessage && _sectionModel.programIncome.questionStatus == questionStatusEnum.L2ValidatedWarning"
            class="has-warning" role="alert">
            <p class="help-block normal">
              <i class="fa fa-warning fa-2x help-block" aria-hidden="true"></i>
              {{_sectionModel.programIncome.businessErrorMessage}}</p>
          </div>
          <div *ngIf="!_sectionModel.programIncome.dataEntryErrorMessage && _sectionModel.programIncome.questionStatus == questionStatusEnum.L2InProgressError"
            class="has-error" role="alert">
            <p class="help-block normal">
              <i class="fa fa-times fa-2x help-block" aria-hidden="true"></i>
              {{_sectionModel.programIncome.businessErrorMessage}}</p>
          </div>
        </div>
        <div class="col-md-9">
          <label for="expendTotal">Total expenditures</label>
        </div>
        <div class="col-md-3 mb-1">
          <div class="form-group">
            <div class="input-group">
              <div class="input-group-addon">$</div>
              <input [(ngModel)]="_sectionModel.expendTotal.elementValue" [disabled]="!_sectionModel.expendTotal.isRequired"
                type="text" class="form-control" id="expendTotal" readonly>
            </div>
          </div>
          <div *ngIf="_sectionModel.expendTotal.dataEntryErrorMessage" class="has-error" role="alert">
            <p class="help-block normal">
              <i class="fa fa-times fa-2x help-block" aria-hidden="true"></i>
              {{_sectionModel.expendTotal.dataEntryErrorMessage}}</p>
          </div>
          <div *ngIf="!_sectionModel.expendTotal.dataEntryErrorMessage && _sectionModel.expendTotal.questionStatus == questionStatusEnum.L2ValidatedWarning"
            class="has-warning" role="alert">
            <p class="help-block normal">
              <i class="fa fa-warning fa-2x help-block" aria-hidden="true"></i>
              {{_sectionModel.expendTotal.businessErrorMessage}}</p>
          </div>
          <div *ngIf="!_sectionModel.expendTotal.dataEntryErrorMessage && _sectionModel.expendTotal.questionStatus == questionStatusEnum.L2InProgressError"
            class="has-error" role="alert">
            <p class="help-block normal">
              <i class="fa fa-times fa-2x help-block" aria-hidden="true"></i>
              {{_sectionModel.expendTotal.businessErrorMessage}}</p>
          </div>
        </div>
        <div class="col-md-9">
          <label for="totalExpendPerUnit" class="normal">Total expenditure per person served</label>
        </div>
        <div class="col-md-3 mb-1">
          <div class="form-group">
            <div class="input-group">
              <div class="input-group-addon">$</div>
              <input [(ngModel)]="_sectionModel.totalExpendPerUnit.elementValue" [disabled]="!_sectionModel.totalExpendPerUnit.isRequired"
                type="text" class="form-control" id="totalExpendPerUnit" readonly>
            </div>
          </div>
          <div *ngIf="_sectionModel.totalExpendPerUnit.dataEntryErrorMessage" class="has-error" role="alert">
            <p class="help-block normal">
              <i class="fa fa-times fa-2x help-block" aria-hidden="true"></i>
              {{_sectionModel.totalExpendPerUnit.dataEntryErrorMessage}}</p>
          </div>
          <div *ngIf="!_sectionModel.totalExpendPerUnit.dataEntryErrorMessage && _sectionModel.totalExpendPerUnit.questionStatus == questionStatusEnum.L2ValidatedWarning"
            class="has-warning" role="alert">
            <p class="help-block normal">
              <i class="fa fa-warning fa-2x help-block" aria-hidden="true"></i>
              {{_sectionModel.totalExpendPerUnit.businessErrorMessage}}</p>
          </div>
          <div *ngIf="!_sectionModel.totalExpendPerUnit.dataEntryErrorMessage && _sectionModel.totalExpendPerUnit.questionStatus == questionStatusEnum.L2InProgressError"
            class="has-error" role="alert">
            <p class="help-block normal">
              <i class="fa fa-times fa-2x help-block" aria-hidden="true"></i>
              {{_sectionModel.totalExpendPerUnit.businessErrorMessage}}</p>
          </div>
        </div>

        <div class="col-md-12 row">
          <div *ngIf="!validForm" class="has-error">
            <p class="help-block">
              There are errors on the page. You must fix the errors or clear the data in those fields in order to Save this form.
            </p>
          </div>
          <button *ngIf="!validForm" data-target="#nextModal" data-toggle="modal" class="btn btn-primary mr-1">Next</button>
          <button *ngIf="validForm" class="btn btn-primary mr-1" (click)="saveAndNext()">Save and next</button>
          <button class="btn btn-default mr-1" (click)="save()" [disabled]="!validForm || !_sectionModel.isRequired">Save</button>
          <a class="btn btn-link pull-right" [routerLink]="['/data-submissions/titleIIIOverview']">Return to Overview</a>
        </div>
        <div aria-labelledby="nextModalLabel" class="modal fade" id="nextModal" role="dialog" tabindex="-1"
             style="display: none;">
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <button aria-label="Close" class="close" data-dismiss="modal" type="button">
                  <span aria-hidden="true">×</span>
                </button>
                <h3 class="modal-title" id="nextModalLabel">
                  Recent changes on this page will not be saved
                </h3>
              </div>
              <div class="modal-body">
                <p>
                  There are errors on the page. You must fix the errors or clear the data in those fields in order to save this form.
                  <br />
                  <br />
                  You may select "Go back to form" to remove the errors or you may select "Proceed to next section" and all of new the data entered in the current section will be lost.
                </p>
              </div>
              <div class="modal-footer">
                <button class="btn btn-primary pull-left" data-dismiss="modal" type="button" href="#">Go back to form</button>
                <button class="btn btn-primary pull-right" data-dismiss="modal" type="button" (click)="next()">Proceed to next section</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- .end col-md-9 -->
    </div>
    <!-- .end acl-container (col-md-12) -->
  </div>
  <!-- .end row -->
</div>
<!-- ./container -->